/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../../state/hooks';

export interface IncidentProps {
  incidentDateTime?: string;
  activity?: string;
  activityOther?: string;
  sessionType?: string;
  sessionTypeOther?: string;
  playType?: string;
  playTypeOther?: string;
  headImpactType?: string;
  headImpactTypeOther?: string;
  redFlags?: boolean;
}

const initialState: IncidentProps = {
  incidentDateTime: '',
  activity: '',
  activityOther: '',
  sessionType: '',
  sessionTypeOther: '',
  playType: '',
  playTypeOther: '',
  headImpactType: '',
  headImpactTypeOther: '',
  redFlags: false,
};

export const incidentCreationViewSlice = createSlice({
  name: 'incidentCreationViewSlice',
  initialState,
  reducers: {
    createIncident: (state, action: PayloadAction<IncidentProps>) => {
      const {
        activity,
        activityOther,
        sessionType,
        sessionTypeOther,
        playType,
        playTypeOther,
        headImpactType,
        headImpactTypeOther,
        incidentDateTime,
        redFlags,
      } = action.payload;
      state.activity = activity;
      state.activityOther = activityOther;
      state.sessionType = sessionType;
      state.sessionTypeOther = sessionTypeOther;
      state.playType = playType;
      state.playTypeOther = playTypeOther;
      state.headImpactType = headImpactType;
      state.headImpactTypeOther = headImpactTypeOther;
      state.incidentDateTime = incidentDateTime;
      state.redFlags = redFlags;
    },
    clearIncident: (state) => {
      state.activity = '';
      state.activityOther = '';
      state.sessionType = '';
      state.sessionTypeOther = '';
      state.playType = '';
      state.playTypeOther = '';
      state.headImpactType = '';
      state.headImpactTypeOther = '';
      state.incidentDateTime = '';
      state.redFlags = false;
    },
  },
});

export const incidentCreationViewSelector = (state: RootState): IncidentProps =>
  state.incidentCreationViewReducer;

export const { createIncident, clearIncident } =
  incidentCreationViewSlice.actions;
